import {Component, OnDestroy, OnInit} from '@angular/core';

import {StateStorageService} from '../../../services/state-storage.service';
import {CommunicationService} from '../../../services/communication.service';
import {TranslateService} from '@ngx-translate/core';
import {marker as _} from '@biesbjerg/ngx-translate-extract-marker';
import {SearchData} from '../../../services/common-datatypes';
import {Subscription} from 'rxjs';
import {AutoUnsubscribe} from '../../../decorators/common.decorators';
import {distinctUntilChanged} from 'rxjs/operators';
import {CommonFunctionsService} from '../../../services/common-functions.service';
import {NavController} from '@ionic/angular';


@Component({
    selector: 'app-device-control',
    templateUrl: './device-control.component.html',
    styleUrls: ['./device-control.component.scss']
})
export class DeviceControlComponent implements OnInit, OnDestroy {

    public firstEnabled = true;
    public skipPrevEnabled = true;
    public prevEnabled = true;
    public nextEnabled = true;
    public skipNextEnabled = true;
    public lastEnabled = true;
    public listDescription = '';
    public countResults = 0;
    public sliderPos = 1;
    public splitPaneVisible = false;

    private messagesSortDescription: { [index: string]: string } = {};
    private messagesSort: { [index: string]: string } = {};
    private emptySearch: SearchData;
    private searchId: number = 0;
    private lastCountResults = 0;
    private blockSlider = false;

    // noinspection JSMismatchedCollectionQueryUpdate
    @AutoUnsubscribe('ngOnDestroy')
    private subscriptions: Subscription[] = [];

    constructor(private navController: NavController,
                public appState: StateStorageService,
                public appCommunication: CommunicationService,
                private translate: TranslateService,
                private commonFunctions: CommonFunctionsService) {
        _('device.allSorted_1');
        _('device.allSorted_2');
        _('device.searchSorted');
        commonFunctions.getTranslations(this.messagesSortDescription,
            ['allSorted_1', 'allSorted_2', 'searchSorted'], 'device.');
        this.commonFunctions.getSortTranslations(this.messagesSort);
        // setup totally empty the search
        this.emptySearch = new SearchData(appState.defaultSearchSort);
        this.emptySearch.onlyDepartment = false;
        this.emptySearch.onlyUsable = false;
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.appState.splitPaneVisible$
                .subscribe((visible: boolean) => {
                    this.splitPaneVisible = visible;
                })
        );
        this.subscriptions.push(this.appCommunication.deviceControlPos$
            .pipe(distinctUntilChanged())
            .subscribe((pos: number) => {
                this.positionUpdate(pos);
            })
        );
        this.subscriptions.push(this.appState.searchData$
            .subscribe((data: SearchData) => {
                this.searchUpdate(data);
            })
        );
    }

    ngOnDestroy(): void {
    }

    private positionUpdate(pos: number) {
        // need to adjust if devices are added
        // this is not perfect as admin has to go back and forth to trigger update ...
        if (this.lastCountResults !== this.appState.searchData.countResults) this.searchUpdate(this.appState.searchData);
        // Note: this.appCommunication.deviceControlPos is zero based, while the slider in the frontend is one based
        this.blockSlider = true;
        this.sliderPos = pos + 1;
        if (0 >= pos) {
            this.firstEnabled = false;
            this.prevEnabled = false;
        } else {
            this.firstEnabled = true;
            this.prevEnabled = true;
        }
        if (9 >= pos) {
            this.skipPrevEnabled = false;
        } else {
            this.skipPrevEnabled = true;
        }
        if (1 >= (this.appState.searchData.countResults - pos)) {
            this.lastEnabled = false;
            this.nextEnabled = false;
        } else {
            this.lastEnabled = true;
            this.nextEnabled = true;
        }
        if (10 >= (this.appState.searchData.countResults - pos)) {
            this.skipNextEnabled = false;
        } else {
            this.skipNextEnabled = true;
        }
        setTimeout(() => {
            this.blockSlider = false;
        });
    }

    private searchUpdate(data: SearchData) {
        if (data.countResults === 0) this.navController.navigateRoot('/search', {queryParams: {sid: this.appState.searchData.id}});
        else {
            this.listDescription = this.getSortOrderDescription(data);
            this.countResults = data.countResults;
            this.searchId = data.id; // unused for now
        }
    }

    public getSortOrderDescription(data: SearchData): string {
        this.lastCountResults = data.countResults;
        let description: string;
        if (this.emptySearch.isSame(data)) {
            description = this.messagesSortDescription['allSorted_1']
                + ' ' + data.countResults.toString() + ' '
                + this.messagesSortDescription['allSorted_2'];
        } else {
            description = data.countResults.toString()
                + ' ' + this.messagesSortDescription['searchSorted'];
        }

        if (this.splitPaneVisible) description += '<br>';

        let searchSort = data.simpleSort;
        if (!data.simple) searchSort = data.sort;
        searchSort.sortItems.forEach((value) => {
            description += ' ' + this.messagesSort[value.name];
        });

        return description;
    }

    public sliderChange(event: any) {
        // Note: this.appCommunication.deviceControlPos is zero based, while the slider in the frontend is one based
        if (this.blockSlider || !event.detail.value) return;
        if (this.appState.editAction) {
            this.commonFunctions.askCancelEdit().then((decision: boolean) => {
                if (decision) this.appCommunication.deviceControlPos = event.detail.value - 1;
            });
        } else this.appCommunication.deviceControlPos = event.detail.value - 1;

    }

    // note: setting this.appCommunication.deviceControlPos resulted in timing problems,
    // so setting the slider and let it report the change
    public first() {
        this.sliderPos = 1;
    }

    public skipPrev() {
        this.sliderPos -= 10;
    }

    public prev() {
        this.sliderPos -= 1;
    }

    public next() {
        this.sliderPos += 1;
    }

    public skipNext() {
        this.sliderPos += 10;
    }

    public last() {
        this.sliderPos = this.countResults;
    }
}
